// extracted by mini-css-extract-plugin
export default {"mainHeader":"MainHeader_mainHeader__-9yep"};